/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_Url_HintInputs */

const vi_shop_home_link_url_hint = /** @type {(inputs: Shop_Home_Link_Url_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://… — chỉ web mở link; Mini App chỉ hiện chữ.`)
};

/**

* @param {Shop_Home_Link_Url_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_url_hint = /** @type {((inputs?: Shop_Home_Link_Url_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_Url_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_url_hint(inputs)
});